import {useContext} from 'react'

import {StoreContext} from '@/src/context/page-store'

import {PageStoreInterface} from '@/src/ports/store/page-store'

export const useStore = <T>(): PageStoreInterface<T> => {
  const store = useContext(StoreContext)
  if (!store) throw new Error('Wrap StoreContext')

  return store
}

